// import { useEffect } from "react";

// type ShortcutMap = { key: string; value: string; label: string }[];

// const useKeyboardShortcuts = (
//   shortcuts: ShortcutMap,
//   callback: (value: { key: string; value: string; label: string }) => void
// ): void => {
//   useEffect(() => {
//     const handleKeyDown = (event: KeyboardEvent): void => {
//       if (event.altKey) {
//         for (const shortcut of shortcuts) {
//           const keys = shortcut.value.split("+");
//           const isMatch = keys.every((key) => {
//             const normalizedKey = key.toLowerCase();
//             if (normalizedKey === "ctrl") {
//               return event.ctrlKey || event.metaKey;
//             }
//             if (normalizedKey === "shift") {
//               return event.shiftKey;
//             }
//             if (normalizedKey === "alt") {
//               return event.altKey;
//             }
//             if (normalizedKey === "meta") {
//               return event.metaKey || (event.ctrlKey && !event.shiftKey);
//             }
//             return event.key.toLowerCase() === normalizedKey;
//           });
//           if (isMatch) {
//             event.preventDefault();
//             callback(shortcut);
//             break;
//           }
//         }
//       }
//     };

//     window.addEventListener("keydown", handleKeyDown);

//     return () => {
//       window.removeEventListener("keydown", handleKeyDown);
//     };
//   }, [shortcuts]);
// };

// export default useKeyboardShortcuts;
import { useEffect } from "react";

type ShortcutMap = { key: string; value: string; label: string; route?: string }[];

const useKeyboardShortcuts = (
    shortcuts: ShortcutMap,
    callback: (value: { key: string; value: string; label: string; route?: string }) => void
): void => {
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent): void => {
            // if (event.altKey) {
            //   let keyValue = "alt+";
            //   if (event.shiftKey) keyValue += "shift+";
            //   keyValue +=
            //     event.code.toLocaleLowerCase() === "space" ? event.code.toLowerCase() : event.key.toLowerCase();

            //   const shortcut = shortcuts.find((s) => s.value.toLowerCase() === keyValue);
            //   if (shortcut) {
            //     event.preventDefault();
            //     callback(shortcut);
            //   }
            // }
            if (event.altKey) {
                // Check if the key combination matches any of the shortcuts
                for (const shortcut of shortcuts) {
                    const keys = shortcut.value.split("+");
                    const isMatch = keys.every((key) => {
                        const normalizedKey = key.toLowerCase();
                        if (normalizedKey === "ctrl") {
                            return event.ctrlKey || event.metaKey;
                        }
                        if (normalizedKey === "shift") {
                            return event.shiftKey;
                        }
                        if (normalizedKey === "alt") {
                            return event.altKey;
                        }
                        if (normalizedKey === "meta") {
                            return event.metaKey || (event.ctrlKey && !event.shiftKey);
                        }
                        return (
                            event.key.toLowerCase() === normalizedKey ||
                            event.code.toLowerCase() === "key" + normalizedKey ||
                            event.code.toLowerCase() === normalizedKey
                        );
                    });
                    if (isMatch) {
                        event.preventDefault();
                        callback(shortcut);
                        break;
                    }
                }
            }
            if (event.key)
                callback({ key: event.key.toLowerCase(), value: event.altKey ? `alt+${event.key.toLowerCase()}` : event.ctrlKey ? `ctl+${event.key.toLowerCase()}` : event.shiftKey ? `shift+${event.key.toLowerCase()}` : event.key.toLowerCase(), label: "default" })

        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [shortcuts, callback]);
};

export default useKeyboardShortcuts;
